import React from 'react';

const authContext = React.createContext({
    authenticated: false,
    login: () => {},
    logout: () => {},
    showSnackBar: () => {},
    message: () => {},
    messageType: () => {}
});

export default authContext;